export default {
      id: "svg-icon-arrow-left-usage",
      viewBox: "0 0 24.063 48",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-arrow-left",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/arrow-left.svg
// module id = xkKn
// module chunks = 4